import { render, staticRenderFns } from "./GolfService.vue?vue&type=template&id=36b9ff1c"
import script from "./GolfService.js?vue&type=script&lang=js&external"
export * from "./GolfService.js?vue&type=script&lang=js&external"
import style0 from "./GolfService.vue?vue&type=style&index=0&id=36b9ff1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports